// extracted by mini-css-extract-plugin
module.exports = {"root":"FileBtn_root__Gbkgm","disabled":"FileBtn_disabled__3Bo4t","warn":"FileBtn_warn__20MJA","fade":"FileBtn_fade__1fkHe"};